import { FormDialog } from '@ui-kit';

interface UserLockToggleProps {
  open: boolean;
  email: string;
  isLocked: boolean;
  isSelf: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  errorMessage?: string;
}

export function UserLockToggle({
  open,
  email,
  isLocked,
  isSelf,
  onClose,
  onConfirm,
  isLoading = false,
  errorMessage,
}: UserLockToggleProps) {
  const action = isLocked ? '잠금 해제' : '잠금';

  return (
    <FormDialog
      open={open}
      title={`사용자 ${action}`}
      onClose={onClose}
      onSubmit={isSelf ? () => {} : onConfirm}
      submitLabel={isLoading ? '처리 중...' : '확인'}
      cancelLabel="취소"
    >
      <div>
        {isSelf ? (
          <div
            role="alert"
            style={{
              padding: 'var(--spacing-3)',
              background: 'color-mix(in srgb, var(--color-warning) 12%, var(--color-surface-muted))',
              border: '1px solid var(--color-warning)',
              borderRadius: 'var(--radius-md)',
              fontSize: 'var(--font-size-sm)',
              color: 'var(--color-warning)',
            }}
          >
            자기 자신을 잠글 수 없습니다. 다른 관리자에게 요청하세요.
          </div>
        ) : (
          <>
            {errorMessage && (
              <div
                role="alert"
                style={{
                  marginBottom: 'var(--spacing-3)',
                  padding: 'var(--spacing-3)',
                  background: 'color-mix(in srgb, var(--color-danger) 12%, var(--color-surface-muted))',
                  border: '1px solid var(--color-danger)',
                  borderRadius: 'var(--radius-md)',
                  fontSize: 'var(--font-size-sm)',
                  color: 'var(--color-danger)',
                }}
              >
                {errorMessage}
              </div>
            )}
            <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-primary)', marginBottom: 'var(--spacing-3)' }}>
              <strong>{email}</strong> 사용자를 {action}하시겠습니까?
            </p>
            {isLocked ? (
              <div
                style={{
                  padding: 'var(--spacing-3)',
                  background: 'color-mix(in srgb, var(--color-success) 8%, var(--color-surface-muted))',
                  border: '1px solid var(--color-success)',
                  borderRadius: 'var(--radius-md)',
                  fontSize: 'var(--font-size-xs)',
                  color: 'var(--color-text-secondary)',
                }}
              >
                잠금 해제 시 로그인 실패 카운터도 초기화됩니다.
              </div>
            ) : (
              <div
                role="alert"
                style={{
                  padding: 'var(--spacing-3)',
                  background: 'color-mix(in srgb, var(--color-warning) 8%, var(--color-surface-muted))',
                  border: '1px solid var(--color-warning)',
                  borderRadius: 'var(--radius-md)',
                  fontSize: 'var(--font-size-xs)',
                  color: 'var(--color-text-secondary)',
                }}
              >
                잠긴 사용자는 로그인할 수 없습니다.
              </div>
            )}
          </>
        )}
      </div>
    </FormDialog>
  );
}
